<template>
    <div id="app" class="menu">
      <h1>Projects</h1>
      <div class="projects-container">
        <ProjectCard 
          v-for="project in projects" 
          :key="project.slug" 
          :project="project" 
        />
      </div>
    </div>
  </template>
  
  <script>
  import ProjectCard from '@/components/projects/ProjectCard.vue';
  import { projectsData } from '@/data/projects.js';
  
  export default {
    name: 'ProjectsView',
    components: {
      ProjectCard
    },
    data() {
      return {
        projects: projectsData
      }
    }
  }
  </script>
  
  <style>
  .projects-container {
    margin: 30px auto;
    max-width: 80%;
  }
  
  @media (max-width: 768px) {
    .projects-container {
      max-width: 95%;
    }
  }
  </style>